import { Component, ElementRef, Injectable, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AppSettings, Settings } from '../app.settings';
import { Enums, IEnums } from '../app.enums';
import * as Api from '../_shared/services/api/api-index';
import * as Entities from '../_shared/entities/index';
import * as _ from 'underscore';
import { UserDetailsEditComponent } from './userDetails/userDetailsEdit.component';

@Component({
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
@Injectable()
export class UsersComponent implements OnInit {
    @ViewChild(MatSort, { static: true }) matSort: MatSort;
    @ViewChild('searchBar', { static: true }) searchBar: ElementRef;
    @ViewChild(MatPaginator, { static: true }) tablePaginator: MatPaginator
    toggleSearchBar = false;
    users: Entities.User[] = [];
    enums: IEnums = Enums;

    settings: Settings;
    viewType = 'list';

    headers: string[] = ['UserName', 'FirstName, LastName', 'role', 'Retailer', 'actions']
    usersDataSource = null;

    constructor(public appSettings: AppSettings, private router: Router,
        private userService: Api.UsersService,
        private dialogService: MatDialog) {
        this.settings = this.appSettings.settings;
    }

    ngOnInit() {

        this.userService.loadUsers();
        this.userService.Users.subscribe((users) => {
            this.users = users.records;
            this.usersDataSource = new MatTableDataSource(this.users);
            this.usersDataSource.sort = this.matSort;
            this.usersDataSource.paginator = this.tablePaginator;
        });
    }

    createEditUser(user?: Entities.User): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;

        if (user) {
            dialogConfig.data = user;
        }
        dialogConfig.panelClass = 'mdModal';

        const dialogRef = this.dialogService.open(UserDetailsEditComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.userService.loadUsers(true);
            }
        });
    }

    filter(event: any): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.usersDataSource.filter = filterValue.trim().toLowerCase();
    }

    showSearch() {
        this.toggleSearchBar = !this.toggleSearchBar;
        this.searchBar.nativeElement.focus();
    }

    view(user: Entities.User): void {
        if (user && user.userId) {
            //window['userLastPage'] = this.paging.currentPage;
            this.router.navigate(['/users', user.userId]);
        }
    }
    getRoleDisplayName(user: Entities.User) {
        // create a list of roles, then join them with a comma
        return user.roles.map(role => role.name).join(', ');
    }
}
